import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import { toast } from 'react-toastify';
import { DateTemplate } from '../dateTemplate/DateTemplate';
import { selectCurrentEmpid, selectCurrentUser } from '../../pages/login/authSlice';
import { changeDateFormate, datetimeToDate } from '../../utils/dateFormat';
import {
    useCreateScorecardWindowCommentsMutation,
    useGetScorecardWindowCommentsQuery,
} from './scorecardWindowCommentsSlice';
import './scorecardWindowComments.scss';
import DescriptionBox from '../descriptionBox/DescriptionBox';

type windowComments = {
    approvalWindowId: number;
    closeCommentsDialog: (message: boolean) => void;
    showCommentsDialog: boolean;
};
export const ScorecardWindowComments = ({
    approvalWindowId,
    closeCommentsDialog,
    showCommentsDialog,
}: windowComments) => {
    const [windowComments, setWindowComments] = useState<any>([]);
    const [expandedRows, setExpandedRows] = useState<any>([]);
    const [addComment, setAddComment] = useState<boolean>(false);
    const [createWindowComment] = useCreateScorecardWindowCommentsMutation();
    const [comment, setComment] = useState('');
    const [ticket, setTicket] = useState('');
    const loggedUser = useSelector(selectCurrentUser);
    const loggedEmpNum = useSelector(selectCurrentEmpid);

    const { data: commentsData } = useGetScorecardWindowCommentsQuery(
        { scorecardApprovalWindowId: approvalWindowId },
        { skip: !approvalWindowId }
    );
    const hideCommentsDialog = () => {
        closeCommentsDialog(true);
        setAddComment(false);
        setWindowComments([]);
    };
    const rowExpansionTemplate = (rowData: any) => {
        return (
            <>
                <div className="me-2 ms-2 commentText">
                    <strong>Comment:</strong>
                </div>
                <div className="col-md-10 me-2 mt-1">
                    <InputTextarea
                        readOnly
                        name="Comment"
                        value={rowData.comment_text}
                        className="w-100 borderRadius8 commentText"
                    />
                </div>
            </>
        );
    };
    const handleCancel = () => {
        setComment('');
        setTicket('');
    };
    const handleSave = () => {
        if (comment === '') {
            toast.error('Please enter the Comment');
            return;
        }
        createWindowComment({
            'scorecard_approval_window_id': approvalWindowId,
            'comment_text': comment,
            'ticket_number': ticket,
            'author': loggedEmpNum,
        })
        .unwrap()
        .then(() => {
            toast.success('Comment added successfully');
            setAddComment(false);
            setComment('');
            setTicket('');
        })
        .then((error: any) => {
            if (error) {
                toast.error('Comment not added successfully, please try again.');
            }
        });
    };

    useEffect(() => {
        if (commentsData?.data.length > 0) {
            const data: any = commentsData?.data.map((element: any) => {
                return {
                    'scorecard_window_comment_id': element.scorecard_window_comment_id,
                    'comment_text': element.comment_text,
                    'comment_Date': new Date(element.comment_Date),
                    'author': element.author,
                    'ticket_number': element.ticket_number,
                };
            });
            setWindowComments(data);
        }
    }, [commentsData]);
    const allowExpansion = (rowData: any) => {
        if (rowData) return true;
        else return false;
    };
    const dateOnchanges = (e: any, options: any) => {
        options.filterCallback(e.value, options.index);
    };
    const dateFilterTemplate = (options: any) => {
        return (
            <Calendar
                value={options.value}
                onChange={(e: any) => dateOnchanges(e, options)}
                dateFormat="mm/dd/yy"
                placeholder="dd/mm/yy"
                mask="99/99/9999"
                showIcon
                className="custom-calendar"
            />
        );
    };
    const dateBodyTemplate = (rowData: any) => {
        return DateTemplate(rowData.comment_Date);
    };

    const handleDescriptionChange = (value: string) => {
        setComment(value);
    };

    return (
        <Dialog
            visible={showCommentsDialog}
            style={{ width: '700px' }}
            header={'Comments'}
            modal
            className="p-fluid disputeModal ms-2"
            onHide={hideCommentsDialog}
        >
            <DataTable
                className="windowCommentsTable ms-1"
                value={windowComments}
                expandedRows={expandedRows}
                onRowToggle={(e) => {
                    setExpandedRows(e.data);
                }}
                rowExpansionTemplate={rowExpansionTemplate}
                dataKey="scorecard_window_comment_id"
                scrollable
                scrollHeight="600px"
                rows={3}
                rowsPerPageOptions={[3, 5, 10, 25, 50]}
                paginator={windowComments?.length > 3}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                emptyMessage=" No Comments found. "
            >
                <Column
                    header="Date"
                    field="comment_Date"
                    headerStyle={{ minWidth: '10rem' }}
                    bodyStyle={{ minWidth: '10rem', color: '#007bff', textDecoration: 'underline' }}
                    sortable
                    sortField="comment_Date"
                    body={dateBodyTemplate}
                    filterField="comment_Date"
                    dataType="date"
                    filter
                    filterElement={dateFilterTemplate}
                />
                <Column
                    header="Ticket"
                    field="ticket_number"
                    headerStyle={{ minWidth: '10rem' }}
                    bodyStyle={{ minWidth: '10rem' }}
                    sortable
                    sortField="ticket_number"
                    filter
                    filterPlaceholder="Search by Ticket"
                />
                <Column
                    header="Author"
                    field="author"
                    headerStyle={{ minWidth: '15rem' }}
                    bodyStyle={{ minWidth: '15rem' }}
                    sortable
                    sortField="author"
                    filter
                    filterPlaceholder="Search by Author"
                />
                <Column key="expand" expander={allowExpansion} style={{ width: '4em' }} />
            </DataTable>
            <Button
                className="btn-primary w-auto float-end mt-1 mb-4"
                // style={{ fontSize: '14px', borderRadius: '8px' }}
                onClick={() => setAddComment(true)}
            >
                Add Comment
            </Button>
            {addComment && (
                <>
                    <div className="logWindowComments mt-5 mb-2 ms-2">
                        <div className="d-flex justify-content-start mb-3 ps-2 pe-2 pb-2">
                            <div className="col-6 me-2">
                                <h6>Creation Date</h6>
                                <div>{changeDateFormate(datetimeToDate(new Date()))}</div>
                            </div>
                            <div className="col-6 me-2">
                                <h6>Ticket Referenced</h6>
                                <div>
                                    <InputText
                                        data-testid="ticket-input"
                                        className="w-100 borderRadius8"
                                        value={ticket}
                                        onChange={(e) => setTicket(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div>
                            <DescriptionBox
                                createdByLabel="Author"
                                createdByValue={loggedUser}
                                title={'Comment'}
                                responseDescription={comment}
                                value={comment}
                                limit={4000}
                                onChange={handleDescriptionChange}
                                className={`borderRadius ${comment === '' ? 'p-invalid' : ''}`}
                            />
                        </div>
                    </div>
                    <div className="flexButtons mt-3">
                        <Button
                            label="Cancel"
                            onClick={handleCancel}
                            className="btn-secondary w-auto me-2"
                        />
                        <Button label="Save" className="btn-primary w-auto" onClick={handleSave} />
                    </div>
                </>
            )}
        </Dialog>
    );
};
